import React from 'react';
import SideNav2 from './SideNav2';
import { Toast } from 'primereact/toast'
import { useAuth } from '../contexts/AuthContext'

const Layout2 = ({ children, items, navTitle }) => {
  const { toast } = useAuth();

  return (
    <div className='d-flex flex-col'>
      <div className="d-sm-flex flex-sm-row flex-grow-1">
        <SideNav2 items={items} navTitle={navTitle} />
        <Toast ref={toast} />
        {children}
      </div>
    </div>
  );
};

export default Layout2;
